import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, message, Modal } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { auth, cloudFunctions } from '../../../config/Fire';
import { setUserById } from '../../../actions/user/setUserById';
import { setError } from '../../../actions/user';
import { getError } from '../../../reducers';
import LoadingPage from '../../components/LoadingPage';
import './styles.css';

const logo = require('../../../images/sade_logo.png');

const LogIn = (props) => {
    const[loading, setLoading] = useState(false)
    const[recoverModalVisibility, setRecoverModalVisibility] = useState(false)
    const[confirmLoadingRecoverModal, setConfirmLoadingRecoverModal] = useState(false)

    const handleSubmit = values => {
        if(!recoverModalVisibility) {
            login(values);
        }
    };

    const login = ({ email, password }) => {
        setLoading(true)
        auth.signInWithEmailAndPassword(email, password)
        .then(()=>{
        })
        .catch((error) => {
            setLoading(false)
            if(error.code && (error.code === "auth/wrong-password" || error.code === "auth/user-not-found")) {
                message.error("Contraseña o usuario incorrecto");
            } else {
                if(error.code && error.code === "auth/invalid-email") {
                    message.error("Correo electrónico incorrecto");
                } else {
                    if(error.code && error.code === "auth/too-many-requests") {
                        cloudFunctions.notifyTooManyRequest({ email: email, type: "WEB" })
                        .then(() => {
                            message.error("¡Demasiados intentos!. Ya se notificó a los administradores de su problema.");
                        })
                        .catch(() => {
                            message.error("¡Demasiados intentos!. Por favor, intente mas tarde o contáctese con soporte.");
                        })
                    } else {
                        console.log(error);
                        message.error("Se produjo un error. Por favor, vuelva a intentarlo.");
                    }
                }
            }
        });
    };

    const showRecoverModal = () => {
        setRecoverModalVisibility(true)
    }

    const hideRecoverModal = () => {
        setRecoverModalVisibility(false)
    }

    const recoverPassword = (values) => {
        if(recoverModalVisibility) {
            setConfirmLoadingRecoverModal(true)
            return auth.sendPasswordResetEmail(values.emailRecover)
            .then((task) => {
                console.log(task)
                message.success("Se envió un correo a su casilla para restablecer la contraseña");
                setConfirmLoadingRecoverModal(false)
                setRecoverModalVisibility(false)
            })
            .catch((err) => {
                if(err.code && err.code === "auth/user-not-found") {
                    message.error("El correo electrónico no se encuentra registrado");
                } else {
                    if(err.code && err.code === "auth/invalid-email") {
                        message.error("El correo electrónico es incorrecto");
                    } else {
                        message.error("Se produjo un error. Refresque la página y vuelva a intentarlo")
                    }
                }
                setConfirmLoadingRecoverModal(false)
            })
        }
    }
        
    return (
        <div>
            {
                loading ?
                    <LoadingPage />
                    :
                    <Form onFinish={handleSubmit} className="login-form">
                        <img alt="logo" src={logo} style={{ display:"block", margin:"auto", maxWidth: "300px", marginBottom: '20px' }} />
                        <Form.Item name="email" rules={[{ required: !recoverModalVisibility, message: 'Por favor, ingrese su correo electrónico' }]}>
                            <Input className="login-input-email"
                            prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Correo electrónico"
                            />
                        </Form.Item>
                        <Form.Item name="password" rules={[{ required: !recoverModalVisibility, message: 'Por favor, ingrese su contraseña' }]}>
                            <Input.Password className="login-input-password"
                            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            type="password"
                            placeholder="Contraseña"
                            />
                        </Form.Item>
                        <Form.Item style={{ textAlign: "center" }}>
                            <Button type="primary" htmlType="submit" className="loginButton">
                                Iniciar sesión
                            </Button>
                        </Form.Item>
                        <Modal
                        title="Recuperar contraseña"
                        visible={recoverModalVisibility}
                        closable={false}
                        footer={null}>
                            <Grid>
                                <Form onFinish={recoverPassword}>
                                    <Form.Item name="emailRecover" label="Email" rules={[{ required: true, message: 'Por favor, ingrese su correo electrónico' }]}>
                                        <Input prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
                                    </Form.Item>
                                    <Row center="xs">
                                        <Col xs={10} md={6}>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit" loading={confirmLoadingRecoverModal}>
                                                    Solicitar
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={10} md={6}>
                                            <Form.Item>
                                                <Button onClick={hideRecoverModal} disabled={confirmLoadingRecoverModal}>
                                                    Cancelar
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Grid>
                        </Modal>
                        <h3 className="recoverCont" onClick={showRecoverModal}>¿No recuerda su contraseña?</h3>
                        <br />
                        <h3 className="contactCont">Contáctenos: <a href="https://www.autosolve.com.ar/" target="_blank" rel="noopener noreferrer">AutoSolve</a></h3>
                    </Form>
            }
        </div>
    );
}

LogIn.propTypes = {
    setError: PropTypes.func.isRequired,
    error: PropTypes.object,
};

const mapDispatchToPropsActions = dispatch => ({
    setUserById: value => dispatch(setUserById(value)),
    setError: value => dispatch(setError(value)),
});

const mapStateToProps = state => ({ 
    error:  getError(state),
});
  
export default connect(mapStateToProps, mapDispatchToPropsActions)(LogIn);